/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

import { ConvivaSession } from './ConvivaSession';
import { Logger } from '@quickplay/foundation';
import { ConvivaSessionImpl } from './internal/ConvivaSessionImpl';
import { ConvivaInitializationData } from './model/ConvivaInitializationData';
import { ConvivaDeviceMetadata, ConvivaPlayerInfo } from './internal/conviva-core-sdk';

/**
 *
 * @param initializationData
 * @param deviceMetadata
 * @param contentPlayerInfo
 * @param adPlayerInfo
 * @param logger
 */
export function createConvivaSession(
  initializationData: ConvivaInitializationData,
  deviceMetadata?: ConvivaDeviceMetadata,
  contentPlayerInfo?: ConvivaPlayerInfo,
  adPlayerInfo?: ConvivaPlayerInfo,
  logger?: Logger,
): ConvivaSession {
  return new ConvivaSessionImpl(initializationData, deviceMetadata, contentPlayerInfo, adPlayerInfo, logger);
}
